import computeNextAuditDate from './computeNextAuditDate'
import findConflictingActiveAudit from './findConflictingActiveAudit'
import formatDate from './formatDate'
import getAuditFrequencyByEnum from './getAuditFrequencyByEnum'
import getEnumRiskByLevel from './getEnumRiskByLevel'
import getInitialLastActiveStep from './getInitialLastActiveStep'
import getRiskLabelByEnum from './getRiskLabelByEnum'
import getRiskLevelByEnum from './getRiskLevelByEnum'
import getRisksTourStepId from './getRisksTourStepId'
import getTreatmentAgentLabelByEnum from './getTreatmentAgentLabelByEnum'
import mountBodyParams from './mountBodyParams'
import mountDefaultValues from './mountDefaultValues'

const thirdPartyManegementPartners = {
  computeNextAuditDate,
  findConflictingActiveAudit,
  formatDate,
  getAuditFrequencyByEnum,
  getEnumRiskByLevel,
  getInitialLastActiveStep,
  getRiskLabelByEnum,
  getRiskLevelByEnum,
  getRisksTourStepId,
  getTreatmentAgentLabelByEnum,
  mountBodyParams,
  mountDefaultValues,
}

export default thirdPartyManegementPartners
